import { createFileRoute, redirect } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { z } from 'zod/mini';
import relayReq, {
    type processDefinitionQuery,
} from '../process-definition/__generated__/processDefinitionQuery.graphql';
import { ProcessDefinition } from '../process-definition/process-definition';
import { processDefinitionsSearchSchema } from '../process-definitions/process-definitions-search-schema';
import { relayEnv } from '../relay/relay-env';
import { spSiteContext } from '../sp-site-context/sp-site-context';
import { getUser } from '../store/userStore';

export const Route = createFileRoute('/process-definition/$id')({
    beforeLoad: async ({ context }) => {
        const user = getUser();
        if (user) {
            const site = await spSiteContext.get(user.siteUrl);
            if (site) {
                return { ...context, site };
            }
        }
        throw redirect({ to: '/no-site' });
    },
    component: ProcessDefinition,
    // loaderDeps: ({ search: { ref } }) => ({ ref }),
    loader: (ctx) => {
        // let id = ctx.params.id;
        /*if (id === 'new' && ctx.deps.ref) {
            id = ctx.deps.ref;
        }*/
        return loadQuery<processDefinitionQuery>(
            relayEnv,
            relayReq,
            { id: ctx.params.id },
            {
                fetchPolicy: 'store-and-network',
            }
        );
    },
    validateSearch: z.object({
        prevPath: z.optional(z.string()),
        prevSearch: z.optional(processDefinitionsSearchSchema),
        // ref: z.optional(z.string()),
    }),
});
